import instance from "../utils/network";

export enum MissionCycle {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum MissionType {
  CUMULATIVE = "CUMULATIVE",
  ONE_OFF = "ONE_OFF",
}

export enum MissionRewardType {
  POINT = "POINT",
  OTHER = "OTHER",
}

export enum SellerPubMissionCategoryFilter {
  ALL = "ALL",
  PERIOD = "PERIOD",
  ALWAYS_ON = "ALWAYS_ON",
}

export enum SellerPubMissionStatus {
  WAITING = "WAITING",
  IN_PROGRESS = "IN_PROGRESS",
  ENDED = "ENDED",
}

export enum SellerPubMissionStatusFilter {
  ALL = "ALL",
  IN_PROGRESS = "IN_PROGRESS",
  ENDED = "ENDED",
}

export interface PubMissionRewardRequest {
  type: MissionRewardType;
  count?: number;
  name?: string;
}

export interface SellerPubMissionRequest {
  pubId: number;
  name: string;
  description: string;
  startDate: Date | string;
  endDate?: Date | string;
  isAlwaysOn: boolean;
  missionCycle?: MissionCycle;
  type: MissionType;
  count?: number;
  rewards: PubMissionRewardRequest[];
}

export interface SellerPubMissionListRequest {
  pubId: number;
  page: number;
  limit: number;
  name?: string;
  category?: SellerPubMissionCategoryFilter;
  status?: SellerPubMissionStatusFilter;
}

export interface SellerPubMissionResetRequest {
  memo?: string;
}

export interface SellerPubMissionRewardResponse {
  type: MissionRewardType;
  count?: number;
  name?: string;
  label: string;
}

export interface SellerPubMissionListItemResponse {
  id: number;
  name: string;
  isAlwaysOn: boolean;
  categoryLabel: string;
  type: MissionType;
  count?: number;
  progressTypeLabel: string;
  periodOrCycleLabel: string;
  rewards: SellerPubMissionRewardResponse[];
  rewardLabel: string;
  createdAt: string;
  status: SellerPubMissionStatus;
  statusLabel: string;
  isEnd: boolean;
  canDelete: boolean;
}

export interface SellerPubMissionListResponse {
  total: number;
  list: SellerPubMissionListItemResponse[];
}

export interface SellerPubMissionDetailResponse {
  id: number;
  pubId: number;
  name: string;
  description: string;
  isAlwaysOn: boolean;
  startDate: string;
  endDate?: string;
  missionCycle?: MissionCycle;
  type: MissionType;
  count?: number;
  isEnd: boolean;
  rewards: SellerPubMissionRewardResponse[];
  canEdit: boolean;
}

export function getPubMissionList(
  request: SellerPubMissionListRequest,
): Promise<SellerPubMissionListResponse> {
  return instance.get("/seller/pub-mission", { params: request });
}

export function getPubMissionDetail(
  id: number,
  pubId: number,
): Promise<SellerPubMissionDetailResponse> {
  return instance.get(`/seller/pub-mission/${id}`, { params: { pubId } });
}

export function createPubMission(
  request: SellerPubMissionRequest,
): Promise<{ code: number; message: string }> {
  return instance.post("/seller/pub-mission", request);
}

export function updatePubMission(
  id: number,
  request: SellerPubMissionRequest,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub-mission/${id}`, request);
}

export function endPubMission(
  id: number,
  pubId: number,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub-mission/${id}/end`, null, {
    params: { pubId },
  });
}

export function resetPubMissionProgress(
  id: number,
  pubId: number,
  request?: SellerPubMissionResetRequest,
): Promise<{ code: number; message: string }> {
  return instance.put(`/seller/pub-mission/${id}/reset`, request ?? {}, {
    params: { pubId },
  });
}

export function deletePubMission(
  id: number,
  pubId: number,
): Promise<{ code: number; message: string }> {
  return instance.delete(`/seller/pub-mission/${id}`, {
    params: { pubId },
  });
}
